import React from 'react';
import { withRouter } from 'react-router';
import { Route, Switch } from 'react-router-dom';
import { ScopeProvider } from '../../../contexts/ScopeContext';
import LegacyPredefinedForm from './print/LegacyPredefinedForm';
import ORScheduleTimeline from './print/ORScheduleTimeline';
import ErrorBoundary from '@/se/components/ErrorBoundary';
import queryString from 'query-string';
import { gql, useQuery } from '@apollo/client';
import { AllChartingData, procedureBaseFields } from '../../../graph/patientChart';
import ChartingQuestionnairesContext from '../../../contexts/ChartingQuestionnairesContext';

const LegacyPredefinedFormRoute = ({ match, location }) => {
  const queryParams = queryString.parse(location.search);

  const { data: patientData } = useQuery(
    gql`
    query procedure($procedureId: Long!) {
      procedure(id: $procedureId) {
        ${procedureBaseFields}
        ${AllChartingData}
      }
    }
  `,
    {
      variables: { procedureId: Number(queryParams.procedureId) },
      skip: !isFinite(Number(queryParams.procedureId)),
    }
  );

  if (!patientData) {
    return null;
  }

  return (
    <ChartingQuestionnairesContext.Provider
      value={{
        preOpCharts: patientData.procedure?.preOpCharts || [],
        orCharts: patientData.procedure?.orCharts || [],
        pacuCharts: patientData.procedure?.pacuCharts || [],
        physicianCharts: patientData.procedure?.physicianCharts || [],
        anesthesiologistPreOpCharts: patientData.procedure?.anesthesiologistPreOpCharts || [],
        anesthesiologistOrCharts: patientData.procedure?.anesthesiologistOrCharts || [],
      }}
    >
      <Route path={`${match.path}/legacy-predefined-form`} component={LegacyPredefinedForm} />
    </ChartingQuestionnairesContext.Provider>
  );
};

const LegacyPredefinedFormRouteWithRouter = withRouter(LegacyPredefinedFormRoute);

const PrintRouter = ({ match }) => (
  <ErrorBoundary>
    <ScopeProvider>
      <Switch>
        <Route path={`${match.path}/or-schedule-timeline`} component={ORScheduleTimeline} />
        <Route path={match.path} component={LegacyPredefinedFormRouteWithRouter} />
      </Switch>
    </ScopeProvider>
  </ErrorBoundary>
);

export default withRouter(PrintRouter);
